var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKubernetesDeployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Apps/Kubernetes/Deployment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Apps/Kubernetes/Deployment",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arch-Category_Compute_64-Copy"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Kubernetes-icon-color",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.0336, 3.6398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5498444,6.04629898 C25.4188509,5.50237441 25.049266,5.04549814 24.5428336,4.80144451 L14.8053589,0.181776273 C14.2942283,-0.0605920909 13.7002738,-0.0605920909 13.1891433,0.181776273 L3.45360163,4.80391419 C2.94704552,5.04781216 2.57733421,5.50466915 2.44631474,6.04863145 L0.0445672389,16.4312912 C-0.0146688153,16.6937301 -0.0148574099,16.9659284 0.0440149226,17.2284481 C0.0613528269,17.3084213 0.0840013192,17.3871659 0.11181175,17.4641651 C0.158813883,17.5955641 0.221045895,17.7210814 0.297251954,17.8381839 C0.330252854,17.8882635 0.365048782,17.936971 0.402882449,17.9841693 L7.14169383,26.3094508 C7.17110467,26.3456728 7.20355326,26.378739 7.23572568,26.4123541 C7.34146204,26.5242414 7.46085958,26.6225559 7.59114123,26.7050108 C7.75591645,26.8080603 7.93548813,26.8856423 8.12371224,26.9351024 C8.27806165,26.9771522 8.43728138,26.9989697 8.59732348,27 L8.7021255,27 L19.4038065,26.9975303 C19.4688634,26.9972448 19.5338566,26.9934432 19.598498,26.9861424 C19.6912241,26.9757251 19.7830298,26.9583884 19.8731372,26.9342791 C19.9377202,26.9173814 20.0013695,26.897139 20.0638245,26.8736349 C20.1125664,26.8551123 20.1611702,26.8365897 20.2081171,26.8142254 C20.2784254,26.7807749 20.346624,26.7431115 20.4123361,26.7014435 C20.5818949,26.5955038 20.7328751,26.462721 20.859298,26.3083532 L21.0647597,26.0545253 L27.5957621,17.9814252 C27.7209393,17.825451 27.8192903,17.6499766 27.8868328,17.462107 C27.9150365,17.3848484 27.9380994,17.3058314 27.9558723,17.2255668 C28.014895,16.9630635 28.0147064,16.6908322 27.95532,16.4284099 L25.5498444,6.04629898 Z",
    id: "Shape",
    fill: "#326CE5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.741709,13.2520797 L20.6024062,13.2601563 L22.9170083,13.2604978 L17.5500573,18.9287301 L15.2257087,13.2604978 L17.8024062,13.2601563 L17.7998147,13.2263677 C17.5360221,10.89043 15.4792617,9.14602252 13.0991145,9.28560315 C10.6468416,9.4294135 8.7714015,11.5199249 8.90167299,13.9635317 C9.03194449,16.407723 11.1186357,18.2877803 13.572669,18.1720305 L13.7111558,21.0868207 C9.64809346,21.2785679 6.19237795,18.1650153 5.97701921,14.1184493 C5.76107367,10.0718833 8.86646448,6.61108141 12.9265928,6.37315128 C16.9873079,6.13463655 20.4788188,9.20785203 20.741709,13.2520797 Z",
    id: "Fill-10",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKubernetesDeployment);
export default __webpack_public_path__ + "static/media/KubernetesDeployment.d136bd4e59d1f1f4dd0c3351a1440a3a.svg";
export { ForwardRef as ReactComponent };